import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TESTIMONIALS_SLIDER_DATA } from "const/data-solution";
import Image from "next/image";
import { Fragment, useRef, useState } from "react";
import Slider from "react-slick";
import Container from "../common/Container";
import PrimaryButton from "../common/PrimaryButton";
import Title from "../common/Title";

const Testimonials = ({ link }) => {
  const [settingsForSlider] = useState({
    centerMode: true,
    centerPadding: "-80px",
    infinite: true,
    slidesToShow: 4.5,
    slidesToScroll: 1,
    speed: 1500,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerPadding: "40px",
        },
      },
    ],
  });

  const TestimonialsSliderReference = useRef();
  return (
    <Fragment>
      <Container large className="pt-20 md:pt-40">
        <Title
          description="When you decide to work with ultroNeous, we do honor the
    responsibility of taking care of your project. Our unwavering
    commitment and drive for innovation balances the performance with
    creativity."
          descriptionClass="text-primary-black text-center mb-0 font-normal text-sm md:text-base font-light md:px-64 pb-10 md:pb-24"
          subTitle="What they say about us"
          subTitleClass="text-4xl md:text-6xl text-primary-black md:pb-6 md:mb-2 mb-4 text-center font-medium"
        />
      </Container>
      <div className="relative overflow-hidden mx-auto max-w-center-page-width">
        <div className="hidden xl:block absolute z-10 left-0 w-96 h-96 top-0 bg-gradient-data-solution-testimonial"></div>
        <Slider
          ref={TestimonialsSliderReference}
          {...settingsForSlider}
          className="testimonialSlider pb-12 mb-4"
        >
          {TESTIMONIALS_SLIDER_DATA.map((value) => (
            <div
              key={value.id}
              className="dataSolutionSlide scale-90 md:scale-100 transition-all duration-500 ease-in p-2"
            >
              <div className="fs-0">
                <Image
                  alt={value.alt}
                  height={187}
                  src={value.src}
                  width={391}
                />
              </div>
              <p className="text-sm md:text-base text-center pt-3 pb-3 mb-0 mt-3 mx-auto w-3/4">
              <span>
                {value.title}
              </span>
              </p>
              <p className="text-base font-bold flex items-center justify-center pb-6">
                <span className="hidden xl:inline-block bg-black mr-2 w-5 h-0.5"></span>
                <span>
                {value.clientName}
                </span>
              </p>
            </div>
          ))}
        </Slider>
        <div className="hidden xl:block absolute z-10 right-0 rotate-180 w-96 h-96 top-0 bg-gradient-data-solution-testimonial"></div>
        <div className="flex gap-6 justify-center">
          <div
            className="rounded-full cursor-pointer border border-solid border-black w-14 h-14 flex justify-center items-center"
            role="presentation"
            onClick={() => TestimonialsSliderReference.current.slickPrev()}
          >
            <FontAwesomeIcon height={24} icon={faAngleLeft} width={13} />
          </div>
          <div
            className="rounded-full cursor-pointer border border-solid border-black w-14 h-14 flex justify-center items-center"
            role="presentation"
            onClick={() => TestimonialsSliderReference.current.slickNext()}
          >
            <FontAwesomeIcon height={24} icon={faAngleRight} width={13} />
          </div>
        </div>
      </div>
      <div className="flex justify-center pt-12">
        <PrimaryButton
          arrow={false}
          link={link}
          val={"Get Free Consultation"}
        />
      </div>
    </Fragment>
  );
};

export default Testimonials;
